import { createFileRoute } from '@tanstack/react-router'
import { FraudAnalysisDatasetLayout, fraudScoreDatasetHealthQueryOptions } from 'features/fraudAnalysis'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset')({
  component: FraudAnalysisDatasetLayout,
  loader: ({ context: { queryClient, buildRequest, fraudScoreEntitlement }, params: { subscriptionId } }) => {
    if (fraudScoreEntitlement === 'disabled') {
      return
    }

    void queryClient.prefetchQuery(fraudScoreDatasetHealthQueryOptions(buildRequest, subscriptionId))
  },
})
